import Vue from "vue";
import { sync } from "vuex-router-sync";
import Service from "@/api/service";

import { initVueVariables } from "@/core/global";
import { createRouter } from "@/router";
import { baseRoutes } from "@/router/routes";
import { createStore } from "@/store";
import { createApi } from "@/api";

import { metaInfo } from "@/core/MetaInfo";
import { sendAnalytics } from "@/core/SendAnalytics";

// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

/**
 * Создания шаблона приложения
 *
 * @param { Object } config - конфигурация бренда(ymId, idGtm, color, ...)
 * @param { Array } routerList - список маршрутов
 * @param { Object } storeList - список хранилищ
 * @param { Object } metaList - список мета-данных для страниц
 * @param { Object } context - контекст приложения
 * @param { Object } renderApp - копмонент входной точки приложения
 * @param { String } nameLinkActiveClass - активный класс
 * @returns {Object}
 */
export const createTemplateApp = ({
    config,
    routerList,
    storeList,
    metaList,
    context,
    renderApp,
    nameLinkActiveClass,
}) => {
    initVueVariables(config);
    // create router

    const routes = [...routerList];
    if (config.name !== "madtech" || config.name !== "finamill") {
        routes.push(...baseRoutes);
    }

    const router = createRouter(routes, nameLinkActiveClass, config.name);
    // create store
    const store = createStore(storeList);
    // create api
    const api = createApi(Vue.prototype.$_url);

    metaInfo.setBrandName(Vue.prototype.$_apiName);
    metaInfo.setDomain(Vue.prototype.$_domain);
    metaInfo.setMetaData(metaList);

    Service.install({ store, api });

    sendAnalytics.updateMetricId(Vue.prototype.$_ymId);

    sync(store, router);

    // if (
    //     process.env.VUE_APP_NAME_SITE === "travel-blue" &&
    //     process.env.VUE_APP_ENV === "client"
    // ) {
    //     Sentry.init({
    //         Vue,
    //         dsn: "https://c176368bcccf4816a962ef53f83619e2@o1121587.ingest.sentry.io/6158316",
    //         integrations: [
    //             new Integrations.BrowserTracing({
    //                 routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //                 tracingOrigins: ["localhost", "travel-blue.ru", "mc.yandex.ru", /^\//],
    //             }),
    //         ],
    //         autoSessionTracking: false,
    //         // Set tracesSampleRate to 1.0 to capture 100%
    //         // of transactions for performance monitoring.
    //         // We recommend adjusting this value in production
    //         tracesSampleRate: 1.0,
    //     });
    // }

    const app = new Vue({
        data: { url: context ? context.url : "" },
        router,
        store,
        render: (h) => h(renderApp),
    });

    if (process.env.VUE_APP_ENV === "client") {
        router.beforeEach((to, from, next) => {
            setTimeout(() => next(), 50);
        });

        router.afterEach((to, from) => {
            if (from.name) {
                Vue.nextTick(() => {
                    let timeout = 100;
                    if (to.name === "Product") timeout = 1200;

                    setTimeout(() => {
                        sendAnalytics.send(sendAnalytics.events.pageview, {
                            toFullPath: to.fullPath,
                            fromFullPath: from.fullPath,
                        });
                    }, timeout);
                });
            }
        });

        router.onError((error) => {
            console.error("Failure Reason: ", error);
            console.warn(error.message);

            if (/Loading chunk.*failed./i.test(error.message)) {
                window.location.reload();
            }
        });
    }

    return { app, router, store };
};
